export default "__VITE_ASSET__D4xJtsZJ__"